module.exports = __webpack_public_path__ + "img/feature_anonymous.7fa1704d.png";